import { lazy, Suspense } from 'react';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import StoreX from '../../../redux/oldStore';
import { IState, ReduxMap } from '../../../redux/redux';
import Icon, { IconType } from '../../../Components/Icon/Icon';
import NhdSchedule from './NhdSchedule';
import JudgeGroupManager from '../../../Components/JudgingSetup/JudgeGroup/JudgeGroupManager';
import NhdAdminPanel from '../../../Components/Client/NHD/NhdAdminPanel';

const AssignSpecialAwards = lazy(() =>
  import('../../../Components/Management/Awards/AssignSpecialAwards').then((m) => ({ default: m.AssignSpecialAwards })),
);

interface IProps extends IState {}

const OutstandingEntry = (props: IProps) => {
  return (
    <Suspense fallback={<div className="bumper">Loading awards...</div>}>
          <AssignSpecialAwards />
    </Suspense>
  );
};

export default ReduxMap(OutstandingEntry);
